import Pomodoro from './Pomodoro';

function App() {
  return (
    <div className='App'>
      <Pomodoro></Pomodoro>
    </div>
  );
}

export default App;
